import { useEffect, useState } from "react";

import { SubmitButton as Button } from "~/components/form/submit-button";
import { useAgent } from "~/hooks/TGEPE/use-agent";
import { SMEsendRespond } from "~/services/TGEPE/agent.services";

interface IModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave?: () => void;
  taskid?: string | null;
  onSubmit: () => void;
}

const ResponseModal = ({ isOpen, onClose, taskid, onSubmit }: IModalProps) => {
  const { values } = useAgent();
  const currentRoute = window.location.hash;

  const taskId =
    isNaN(Number(values?.header[0]["taskid"])) ||
    values?.header[0]["taskid"] === null
      ? taskid
        ? Number(taskid)
        : NaN
      : Number(values?.header[0]["taskid"]);

  const [description, setDescription] = useState<string>("");
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const roleid = localStorage.getItem("roleid") as string;

  const handleDescription = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setDescription(event.target.value);
  };

  const sendResponse = async () => {
    setIsLoading(true);
    const response = await SMEsendRespond(taskId, roleid, {
      dbdata: {
        response: description,
      },
    });
    if (response.status) {
      setIsLoading(false);
      setIsSubmitted(true);

      // if(roleid==='8'){
      onSubmit();
      //}

      console.log("data refreshed");

      setTimeout(() => {
        onClose();

        if (currentRoute !== "#/supervisor/exception") {
          window.close();
        }
      }, 1000);
    }
  };

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.ctrlKey && (event.key).toLowerCase() === "q") {
        event.preventDefault();
        onClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [onClose]);

  useEffect(() => {
    if (!isOpen) {
      setDescription("");
      setIsSubmitted(false);
      setIsLoading(false);
    }
  }, [isOpen]);

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div className="fixed inset-0 bg-gray-800 opacity-50"></div>
          <div className="bg-white rounded-2xl p-8 z-50 max-w-lg w-full">
            {!isSubmitted && (
              <>
                <h1 className="text-center text-2xl font-semibold text-gray-900 mb-4">
                  Respond to WNS SME
                </h1>

                <div className="mb-4">
                  <label
                    className="block text-sm font-medium text-gray-700"
                    htmlFor="description"
                  >
                    Response Message
                  </label>
                  <textarea
                    id="description"
                    name="description"
                    rows={3}
                    className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    placeholder="Enter description here..."
                    value={description}
                    onChange={handleDescription}
                  ></textarea>
                </div>
                <div className="flex flex-row-reverse gap-2">
                  <Button
                    role="button"
                    radius="full"
                    size="medium"
                    onClick={sendResponse}
                    disabled={description.trim() === ""}
                    type="button"
                  >
                    Submit
                  </Button>
                  <Button
                    role="button"
                    variant="secondary"
                    radius="full"
                    size="medium"
                    onClick={onClose}
                  >
                    Cancel
                  </Button>
                </div>
              </>
            )}
            {isLoading && (
              <div className="spinner-border animate-spin border-4 border-orange-400 border-t-transparent w-5 h-5 rounded-full"></div>
            )}
            {isSubmitted && (
              <div className="text-center">
                <div className="flex justify-center mb-4">
                  <img
                    src="/images/greentick.gif"
                    alt="Example Image"
                    width={80}
                    height={80}
                  ></img>
                </div>
                <h1 className="text-center text-2xl font-semibold text-gray-900 mb-4">
                  Response Submitted successfully!
                </h1>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ResponseModal;
